// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1AReS","clinicsSelect":"TableHeading_clinicsSelect__39_20"};